// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margin {
  margin: 2rem 0;
  color: #808080;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.margin .big-span {
  font-size: 18px;
  color: var(--ion-color-primary);
  font-weight: 600;
  text-align: right;
}
.margin div {
  display: flex;
  align-items: center;
}
.margin div .popup-icon {
  font-size: 3rem;
  margin-right: 10px;
}

.close {
  width: 150px;
  height: 55px;
  margin: 5rem auto 2rem auto;
  display: grid;
}

:host ::ng-deep .close ion-button {
  width: 150px;
  height: 55px;
  font-size: 22px;
  font-weight: 600;
}

.titolo-ordinamento {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  display: block;
  padding-bottom: 20px;
  color: var(--ion-color-primary);
  line-height: 1.5;
  width: 200px;
  margin: 0 auto;
}

#map_canvas {
  opacity: 0;
  transition: opacity 500ms ease-in;
  background-color: transparent;
}

#map_canvas.show-map {
  opacity: 1;
}

.map-container {
  height: 200px;
  width: 80;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/info-popover/info-popover.component.scss"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AACI;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;AACR;AACI;EACI,aAAA;EACA,mBAAA;AACR;AAAQ;EACI,eAAA;EACA,kBAAA;AAEZ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,+BAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAEJ;;AAGA;EAGE,UAAA;EACA,iCAAA;EACA,6BAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAMA;EACM,aAAA;EACA,SAAA;AAHN","sourcesContent":["\n.margin {\n    margin: 2rem 0;\n    color: #808080;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .big-span {\n        font-size: 18px;\n        color: var(--ion-color-primary);\n        font-weight: 600;\n        text-align: right;\n    }\n    div {\n        display: flex;\n        align-items: center;\n        .popup-icon {\n            font-size: 3rem;\n            margin-right: 10px;\n        }\n    }\n}\n.close {\n    width: 150px;\n    height: 55px;\n    margin: 5rem auto 2rem auto;\n    display: grid;\n\n}\n:host ::ng-deep .close ion-button {\n    width: 150px;\n    height: 55px;\n    font-size: 22px;\n    font-weight: 600;\n}\n.titolo-ordinamento {\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n    display: block;\n    padding-bottom: 20px;\n    color: var(--ion-color-primary);\n    line-height: 1.5;\n    width: 200px;\n    margin: 0 auto;\n}\n\n\n\n#map_canvas {\n  //height: 100%;\n  //width: 100%;\n  opacity: 0;\n  transition: opacity 500ms ease-in;\n  background-color : transparent;\n}\n\n#map_canvas.show-map {\n  opacity: 1;\n  //position: fixed;\n}\n\n.map-container {\n      height: 200px;\n      width: 80;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
